/* eslint-disable */
import { UserLayout, BasicLayout, PageView } from '@/layouts'

const RouteView = {
  name: 'RouteView',
  render: (h) => h('router-view')
}

export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '主页' },
    redirect: '/fs/goods_category',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/Workplace',
        component: PageView,
        hidden: true,
        meta: { title: '概览', keepAlive: true, icon: 'dashboard' },
        children: [
          {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: () => import('@/views/dashboard/Workplace'),
            meta: { title: '快捷导航', keepAlive: true }
          }
        ]
      },
      {
        path: '/fs/goods',
        component: PageView,
        redirect: '/fs/goods_category',
        name: 'shop_goods',
        meta: { title: '商品管理', icon: 'shop' },
        children: [
          {
            path: '/fs/goods_category',
            name: 'FSGoodsCategoryList',
            component: () => import('@/views/goods_category/Category'),
            meta: { title: '商品分类'}
          },
          {
            path: '/fs/shop_goods',
            name: 'FSGoodsList',
            component: () => import('@/views/shop_goods/list'),
            meta: { title: '商品列表'}
          },
          {
            path: '/fs/shop_goods/create',
            name: 'FSGoodsCreate',
            hidden: true,
            component: () => import('@/views/shop_goods/create'),
            meta: { title: '商品创建'}
          },
          {
            path: '/fs/shop_goods/edit',
            name: 'FSShopGoodsEdit',
            hidden: true,
            component: () => import('@/views/shop_goods/edit'),
            meta: { title: '商品编辑' }
          },
          {
            path: '/fs/shop_goods/vip_price',
            hidden: true,
            component: () => import('@/views/shop_goods/goods_price/PriceList'),
            name: 'GoodsPrice',
            meta: {
              title: '商品会员价'
            }
          },
          {
            path: '/fs/shop_goods/count_record',
            hidden: true,
            component: () => import('@/views/shop_goods/CountRecordList'),
            name: 'GoodsCountRecord',
            meta: {
              title: '商品数量变动记录'
            }
          },
          {
            path: '/fs/order/list',
            name: 'FSOrderList',
            component: () => import('@/views/order/OrderList'),
            meta: { title: '订单列表'}
          },
          {
            path: '/fs/order/detail',
            name: 'FSOrderDetail',
            hidden: true,
            component: () => import('@/views/order/OrderDetail'),
            meta: { title: '订单列表'}
          },
        ]
      },
      // account
      {
        path: '/account/settings',
        component: PageView,
        redirect: '/account/settings/base',
        hidden: true,
        name: 'account',
        meta: { title: '个人页', icon: 'user', keepAlive: true, permission: [ 'user_settings' ] },
        children: [
          {
            path: '/account/settings/base',
            name: 'settings',
            component: () => import('@/views/account/settings/BaseSetting'),
            meta: { title: '个人设置', hideHeader: true, permission: [ 'user_settings' ] }
          }
        ]
      },
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
      },
      {
        path: 'recover',
        name: 'recover',
        component: undefined
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }
]
